module.exports = __webpack_public_path__ + "img/sheets.b6ba932b.svg";